import AdditionalInfo from "./AdditionalInfo";
import Head from "./Head";
import PriceCalculation from "./PriceCalculation";
import ServiceDescription from "./ServiceDescription";
import ServiceObjects from "./ServiceObjects";

export {
  AdditionalInfo,
  Head,
  PriceCalculation,
  ServiceDescription,
  ServiceObjects,
};
